import { ChangeDetectionStrategy, Component, EventEmitter, OnInit, Output } from "@angular/core";
import { actionsExecuting } from "@ngxs-labs/actions-executing";
import { UntilDestroy, untilDestroyed } from "@ngneat/until-destroy";
import { Actions, ofActionSuccessful, Select, Store } from "@ngxs/store";
import { map, Observable } from "rxjs";
import { PermitUserActions } from "../../../shared/states/permit-user.action";

import { PermitType } from "@ha/data/basic";
import { PermitWorkPlaceViewEnum } from "../../models/permit-work-place-view.enum";
import { PermitCreateActions } from "../../states/permit-create.actions";
import { PermitCreateSelectors } from "../../states/permit-create.selectors";
import { PermitWorkplaceActions } from "../../states/permit-workplace.actions";
import { PermitWorkplaceSelectors } from "../../states/permit-workplace.selectors";

@UntilDestroy()
@Component({
    selector: "pmt-workplace",
    templateUrl: "permit-workplace.component.html",
    styleUrls: ["permit-workplace.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PermitWorkplaceComponent implements OnInit {
    @Output()
    public affirmative = new EventEmitter<boolean>();

    @Select(PermitWorkplaceSelectors.view)
    public view$: Observable<PermitWorkPlaceViewEnum>;

    public creatingPermit$ = this.store.select(
        actionsExecuting([
            PermitWorkplaceActions.UpdatePermit,
            PermitWorkplaceActions.SetWorkplaceAndEmergencyLocation,
            PermitWorkplaceActions.SetPremiumWorkplace,
            PermitWorkplaceActions.SetPremiumWorkplaceFromHistory,
        ]),
    ).pipe(map((_) => {
        return _ === null ? undefined : true;
    }));

    public permitWorkPlaceViewEnum = PermitWorkPlaceViewEnum;

    constructor(private store: Store, private actions$: Actions) {}

    public ngOnInit(): void {
        this.store.dispatch(new PermitWorkplaceActions.ChangeView(PermitWorkPlaceViewEnum.Start));
        this.loadCompanyStructure();

        this.actions$.pipe(
            ofActionSuccessful(PermitCreateActions.GetPermit),
            untilDestroyed(this),
        ).subscribe(() => this.loadCompanyStructure());

        this.store.dispatch(new PermitUserActions.GetCurrentPerson());
    }

    private loadCompanyStructure(): void {
        const permit = this.store.selectSnapshot(PermitCreateSelectors.permit);

        if (!permit) {
            return;
        }

        if (permit.type === PermitType.hotWork) {
            this.store.dispatch(new PermitWorkplaceActions.GetCurrentIssuerCompanyStructure());
            return;
        }

        this.store.dispatch(new PermitWorkplaceActions.GetSuperintendentCompanyStructure());
    }
}
